import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, DollarSign, Calculator } from 'lucide-react';
export function Sidebar() {
  return <div className="w-60 bg-slate-700 text-white flex flex-col h-full" data-id="element-193">
      <div className="p-4 flex items-center gap-2 border-b border-slate-600" data-id="element-194">
        <DollarSign size={24} data-id="element-195" />
        <h1 className="text-xl font-semibold" data-id="element-196">FPX</h1>
      </div>
      <nav className="flex-1 py-4" data-id="element-197">
        <NavLink to="/" className={({
        isActive
      }) => `flex items-center gap-3 px-4 py-3 ${isActive ? 'bg-slate-600' : 'hover:bg-slate-600'}`} data-id="element-198">
          <Home size={20} data-id="element-199" />
          <span data-id="element-200">Display</span>
        </NavLink>
        <NavLink to="/cashflow" className={({
        isActive
      }) => `flex items-center gap-3 px-4 py-3 ${isActive ? 'bg-slate-600' : 'hover:bg-slate-600'}`} data-id="element-201">
          <DollarSign size={20} data-id="element-202" />
          <span data-id="element-203">Cashflow</span>
        </NavLink>
        <NavLink to="/taxmax" className={({
        isActive
      }) => `flex items-center gap-3 px-4 py-3 ${isActive ? 'bg-slate-600' : 'hover:bg-slate-600'}`} data-id="element-204">
          <Calculator size={20} data-id="element-205" />
          <span data-id="element-206">TaxMax</span>
        </NavLink>
      </nav>
    </div>;
}